<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect" v-if="showSearchBar && searchBar.searchColums.length>0">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item :label="sitem.label+':'" v-for="(sitem,sindex) in searchBar.searchColums">
                    <el-input v-if="sitem.type === 'input'" size="default" v-model="formInline[sitem.prop]" :maxlength="sitem.maxlength"  clearable :placeholder="sitem.placeholder" @change="search" :style="{width:(sitem.width?sitem.width:200)+'px'}"></el-input>
                    <el-select v-else-if="sitem.type === 'select'" size="default" v-model="formInline[sitem.prop]" :placeholder="sitem.placeholder" clearable filterable :style="{width:(sitem.width?sitem.width:200)+'px'}" @change="search">
                        <el-option
                                v-if="sitem.options"
                                v-for="option in sitem.options"
                                :key="option.value"
                                :label="option.label"
                                :value="option.value"
                                >
                        </el-option>
                    </el-select>
                    <el-date-picker
                            v-else-if="sitem.type === 'datepicker-datetimerange'"
                            style="width:350px"
                            v-model="timers"
                            type="datetimerange"
                            @change="timeChange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <slot name="searchBar"></slot>
                <el-form-item label=""><el-button  @click="handleSearchClick('search')" type="primary" icon="Search" v-show="rowHandle.permission.search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="handleSearchClick('reset')" icon="Refresh">重置</el-button></el-form-item>
<!--                <el-form-item label=""><el-button  @click="addAdmin" type="primary" v-show="isShowBtn('userManage','用户管理','Create')">新增</el-button></el-form-item>-->
<!--                <el-form-item label=""><el-button  @click="exportDataBackend" type="primary">导出</el-button></el-form-item>-->
            </el-form>
        </div>

        <div class="table">
            <!-- 表格头部操作栏 -->
            <div class="tableToolBar" ref="tableToolBar">
                <!-- 左侧按钮栏目 -->
                <div>
                   

                </div>
                <div>
                    <slot name="tablebar-c"></slot>
                </div>
                <div>
                    <slot name="tablebar-r"></slot>
                    <!-- 右侧表头筛选 -->
<!--                    <div class="transfer">-->
<!--                        <el-button icon="Refresh" circle @click="handleRefresh"></el-button>-->
<!--                        <el-button icon="Search" circle type="primary" @click="showSearchBar=showSearchBar?false:true"></el-button>-->
<!--                        <el-button icon="Filter" @click="drawer=true" circle type="success"></el-button>-->
<!--                        <el-drawer v-model="drawer" direction="rtl" title="显示/隐藏列" size="20%">-->
<!--                            <el-checkbox :indeterminate="drawerIndeterminate" @change="handleDrawerCheckAllChange">全选 {{ "("+drawerCheckedValue.length+"/"+tableColumns.length+")"}}</el-checkbox>-->
<!--                            <el-checkbox-group v-model="drawerCheckedValue" @change="handleDrawerColumnsChange" style="overflow: auto;display: flex;flex-direction: column">-->
<!--                                <el-checkbox  v-for="ckitem in tableColumns" :key="ckitem.prop" :label="ckitem.label" :checked="!ckitem.hidden"></el-checkbox>-->
<!--                            </el-checkbox-group>-->

<!--                        </el-drawer>-->
<!--                    </div>-->
                    <div class="transfer">
                        <el-button type="primary" link @click="handleRefresh">
                            <el-icon size="20px"><Refresh/></el-icon>
                        </el-button>
                        <el-popover placement="bottom" trigger="click" :width="100">
                            <el-checkbox :indeterminate="drawerIndeterminate" @change="handleDrawerCheckAllChange">全选 {{ "("+drawerCheckedValue.length+"/"+tableColumns.length+")"}}</el-checkbox>
                            <el-divider style="margin:  5px auto"></el-divider>
                            <el-checkbox-group v-model="drawerCheckedValue" @change="handleDrawerColumnsChange" style="overflow: auto;display: flex;flex-direction: column">
                                <el-checkbox  v-for="ckitem in tableColumns" :key="ckitem.prop" :label="ckitem.label" :checked="!ckitem.hidden"></el-checkbox>
                            </el-checkbox-group>
                            <template #reference>
                                <el-button link type="primary">
                                    <el-icon size="20px"><Setting/></el-icon>
                                </el-button>
                            </template>
                        </el-popover>
                        <el-button link type="primary" @click="showSearchBar=!showSearchBar">
                            <el-icon size="20px"><Search/></el-icon>
                        </el-button>
                        <el-button type="primary" link @click="setFull">
                            <el-icon size="20px"><FullScreen/></el-icon>
                        </el-button>
                    </div>
                </div>
            </div>
            <el-table  v-bind="tableOptions" :height="tableHeight" :data="tableData" ref="tableref" v-loading="loadingPage" :row-key="rowKey" style="width: 100%" @selection-change="handleSelectionChange">
                <!-- 选择框列/序号列是否开启 -->
                <el-table-column type="selection" width="55" align="center" v-if="showSelectable"></el-table-column>
                <el-table-column type="index" width="60" align="center" label="序号" v-if="showSequence">
                     <template #default="scope">
                         <span v-text="getTableIndex(scope.$index)"></span>
                     </template>
                </el-table-column>
                <!-- 普通列 -->
                <template v-for="(column,columnIndex) in tableColumns" :key="columnIndex">
                    <span v-if="column.slot" >
                        <slot :name="column.slot" :tit="columnIndex"></slot>
                    </span>
                    <el-table-column
                    :prop="column.prop"
                    :label="column.label"
                    :sortable="column.sortable"
                    :min-width="column.minWidth"
                    :show-overflow-tooltip="true"
                    v-if="(column.hidden !== undefined && column.slot==undefined)?!column.hidden:true"
                    >
                        <template #default="{row,$index}">
                            <template v-if="!column.render">
                                <span>{{ row[column.prop]}}</span>
                            </template>
                            <template v-else>
                                <ly-render :render="column.render" :row="row" :index="$index" :column="column" ></ly-render>
                            </template>
                        </template>
                    </el-table-column>
                </template>
                <!-- 操作列 -->
              
                <!-- 自定义空数据 -->
                <template v-slot:empty>
                     <el-empty :image-size="150" description="暂无数据" />
                </template>
            </el-table>
        </div>
        <!-- 分页 -->
        <Pagination v-bind:child-msg="pageparm" :page-options="pageparams" @callFather="callFather" v-if="showPagination"></Pagination>
        <!-- 弹窗 -->
        <ly-dialog v-model="isDialogShow" :title="dialogTitle" :width="formOptions.width?formOptions.width:'50%'" :before-close="handleDialogClose">
            <el-form :model="formData" :rules="rules" ref="rulesForm" label-width="auto" :disabled="formDisabled">
                <el-row :gutter="formOptions.gutter?formOptions.gutter:20">
                    <el-col :span="fitem.form.span?fitem.form.span:24" v-for="(fitem,findex) in formColumns">
                        <el-form-item :label="fitem.label+'：'" :prop="fitem.prop" v-if="(fitem.form.hidden!==undefined && dialogTitle!=='详情')?!fitem.form.hidden:true">
                            <el-input v-if="fitem.type=='input'" :show-password="fitem.form.showPassword?fitem.form.showPassword:false"  v-model="formData[fitem.prop]" clearable :placeholder="fitem.form.placeholder?fitem.form.placeholder:''" @change="fitem.form.valueChange"></el-input>
                            <el-input v-else-if="fitem.type=='textarea'"  type="textarea" v-model="formData[fitem.prop]" :placeholder="fitem.form.placeholder?fitem.form.placeholder:''" @change="fitem.form.valueChange"></el-input>
                            <el-input-number v-else-if="fitem.type=='number'"  v-model="formData[fitem.prop]"  :min="0" :max="999999" @change="fitem.form.valueChange"></el-input-number>
                            <el-input-number v-else-if="fitem.type=='price'"  v-model="formData[fitem.prop]" :precision="2" :step="0.1"    @change="fitem.form.valueChange"></el-input-number>
                            <el-switch v-else-if="fitem.type=='switch'" v-model="formData[fitem.prop]" active-color="#13ce66" inactive-color="#ff4949" @change="fitem.form.valueChange"></el-switch>
                            <el-select v-else-if="fitem.type === 'select'" v-model="formData[fitem.prop]" :placeholder="fitem.placeholder" clearable filterable  @change="fitem.form.valueChange" style="width: 100%;">
                                <el-option
                                        v-if="fitem.form.options"
                                        v-for="option in fitem.form.options"
                                        :key="option.value"
                                        :label="option.label"
                                        :value="option.value"
                                        >
                                </el-option>
                            </el-select>
                            <el-radio-group v-else-if="fitem.type=='radio'" v-model="formData[fitem.prop]" @change="fitem.form.valueChange">
                                <el-radio :label="rditem.value" v-for="(rditem,rdindex) in fitem.form.options">{{rditem.label}}</el-radio>
                            </el-radio-group>
                            <el-checkbox-group v-else-if="fitem.type=='checkbox'" v-model="formData[fitem.prop]" @change="fitem.form.valueChange">
                                <el-checkbox v-if="fitem.options"  v-for="option in fitem.options" :label="option.label" />
                            </el-checkbox-group>
                            <ly-upload-avatar v-else-if="fitem.type=='image-avatar'" v-model="formData[fitem.prop]" :width="fitem.form.width?fitem.form.width+'px':'80px'" :height="fitem.form.width?fitem.form.width+'px':'80px'"></ly-upload-avatar>
                            <ly-upload-goods v-else-if="fitem.type=='image-goods'" v-model="formData[fitem.prop]"></ly-upload-goods>
                            <t-editor v-else-if="fitem.type=='tinymce'" v-model="formData[fitem.prop]"></t-editor>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 自定义form部分 -->
                <slot name="formExtend" :formData="formData"></slot>
            </el-form>
            <template v-slot:footer>
                <el-button @click="handleDialogClose">取消</el-button>
                <el-button @click="submitData" type="primary" :loading="loadingSave" :disabled="formDisabled">确定</el-button>
                <!-- 自定义dialog底部按钮 -->
                <slot name="customDialogHandle"></slot>
            </template>
        </ly-dialog>
    </div>
</template>
<script>
    //ly-crud需要的组件/方法
    import {dateFormats,getTableHeight} from "@/utils/util";
    import Pagination from "@/components/pagination/pagination";
    import LyRender from "./render/render";
    import LyDialog from "./dialog/dialog";
    import LyUploadAvatar from "./upload/avatar";
    import TEditor from "./TEditor";
    import LyUploadGoods from "./upload/goods";
    import eq_manage from "../views/eq_list/eq_manage.vue";
import { it } from "element-plus/es/locale";
    export default {
        components:{
            LyUploadGoods,
            TEditor,
            LyUploadAvatar,
            LyDialog,
            LyRender,
            Pagination,
        },
        name:'LyCrud',
        data() {
            return {
                column1:[{label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'设备类型',prop:'device_type',minWidth:'200',sortable: false,hidden:false},
                         {label:'在线状态',prop:'onlineflag',minWidth:'100',sortable: false,hidden:false},
                         {label:'创建时间',prop:'creted_time',minWidth:'130',sortable: false,hidden:false},  
                         {label:'最后更新时间',prop:'update_time',minWidth:'100',sortable: false,hidden:false},
                         {label:'LOGO',prop:'logo',minWidth:'150',sortable: false,hidden:false},
                         {label:'生产日期',prop:'product_date',minWidth:'100',sortable: false,hidden:false},
                         {label:'软件版本',prop:'soft_ver',minWidth:'100',sortable: false,hidden:false}],

                column2:[{label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'物料性质',prop:'medium',minWidth:'200',sortable: false,hidden:false},
                         {label:'回波强度',prop:'echo_intensity',minWidth:'100',sortable: false,hidden:false},
                         {label:'显示内容',prop:'show_type',minWidth:'130',sortable: false,hidden:false},  
                         {label:'当前空高(mm)',prop:'cur_empty_distance',minWidth:'100',sortable: false,hidden:false},
                         {label:'当前料高',prop:'cur_material_distance',minWidth:'150',sortable: false,hidden:false},
                         {label:'当前料高百分比',prop:'cur_material_percent',minWidth:'100',sortable: false,hidden:false},
                         {label:'当前电流',prop:'cur_value',minWidth:'100',sortable: false,hidden:false},
                         {label:'当前海拔',prop:'cur_altitude',minWidth:'100',sortable: false,hidden:false},
                         {label:'低位调整值',prop:'low_adj_value',minWidth:'130',sortable: false,hidden:false},  
                         {label:'高位调整值',prop:'high_adj_value',minWidth:'100',sortable: false,hidden:false},
                         {label:'低位百分比',prop:'low_adj_percent',minWidth:'150',sortable: false,hidden:false},
                         {label:'高位百分比',prop:'high_adj_percent',minWidth:'100',sortable: false,hidden:false},
                         {label:'单位',prop:'unit',minWidth:'100',sortable: false,hidden:false},
                         {label:'表面流速',prop:'Surface_velocity',minWidth:'130',sortable: false,hidden:false},  
                         {label:'当前流速',prop:'Current_velocity',minWidth:'100',sortable: false,hidden:false},
                         {label:'横滚角',prop:'Angle_of_roll',minWidth:'150',sortable: false,hidden:false},
                         {label:'俯仰角',prop:'Angle_of_pitch',minWidth:'100',sortable: false,hidden:false},
                         {label:'当前测速等级',prop:'Current_speed_level',minWidth:'100',sortable: false,hidden:false},
                         {label:'回波位置',prop:'Echo_position',minWidth:'130',sortable: false,hidden:false},  
                         {label:'水流方向',prop:'Flow_direction',minWidth:'100',sortable: false,hidden:false},
                        ],
                column3:[{label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'低位调整值',prop:'low_adj_value',minWidth:'200',sortable: false,hidden:false},
                        {label:'低位百分比',prop:'low_adj_percent',minWidth:'100',sortable: false,hidden:false},
                         {label:'高位调整值',prop:'high_adj_value',minWidth:'130',sortable: false,hidden:false},  
                         {label:'高位百分比',prop:'high_adj_percent',minWidth:'100',sortable: false,hidden:false},
                         {label:'物料性质',prop:'medium',minWidth:'150',sortable: false,hidden:false},
                         {label:'水位快速变化',prop:'water_fast_change',minWidth:'100',sortable: false,hidden:false},
                         {label:'选择首波',prop:'water_first_echo',minWidth:'100',sortable: false,hidden:false},
                         {label:'表面波动',prop:'sur_wave',minWidth:'100',sortable: false,hidden:false},
                         {label:'泡沫',prop:'foam',minWidth:'130',sortable: false,hidden:false},  
                         {label:'DK值小',prop:'DKsmall_water',minWidth:'100',sortable: false,hidden:false},
                         {label:'导波管测量',prop:'wave_guide',minWidth:'150',sortable: false,hidden:false},
                         {label:'物位快速变化',prop:'material_fast_change',minWidth:'100',sortable: false,hidden:false},
                         {label:'选择首波',prop:'material_first_echo',minWidth:'100',sortable: false,hidden:false},
                         {label:'堆角大',prop:'sa_big',minWidth:'130',sortable: false,hidden:false},  
                         {label:'粉尘强',prop:'dust',minWidth:'100',sortable: false,hidden:false},
                         {label:'DK值小低介电常数',prop:'DKsmall_low_k',minWidth:'150',sortable: false,hidden:false},
                         {label:'空罐空高',prop:'empty_span',minWidth:'100',sortable: false,hidden:false},
                         {label:'真实料高',prop:'real_material_high',minWidth:'100',sortable: false,hidden:false},
                         {label:'DK值',prop:'DK_value',minWidth:'130',sortable: false,hidden:false},  
                         {label:'阻尼时间',prop:'damp_value',minWidth:'100',sortable: false,hidden:false},
                         {label:'量程设定',prop:'range',minWidth:'100',sortable: false,hidden:false},
                         {label:'盲区',prop:'near_blank',minWidth:'100',sortable: false,hidden:false},
                         {label:'传感器标签',prop:'sensor_tag',minWidth:'130',sortable: false,hidden:false},  
                         {label:'管道直径',prop:'wave_guide_dia',minWidth:'100',sortable: false,hidden:false},
                         {label:'量程限制',prop:'RangeLimit',minWidth:'100',sortable: false,hidden:false},
                         {label:'速度模式',prop:'SpeedMode',minWidth:'100',sortable: false,hidden:false},
                         {label:'水文类型',prop:'hydrology',minWidth:'130',sortable: false,hidden:false},  
                         {label:'开放河床-安装高度',prop:'riverBed_MountingHeight',minWidth:'100',sortable: false,hidden:false},
                         {label:'开放河床-离岸距离',prop:'riverBed_OffshoreDistance',minWidth:'100',sortable: false,hidden:false},
                         {label:'梯形沟渠-安装高度',prop:'trapezoidalDitch_MountingHeight',minWidth:'100',sortable: false,hidden:false},
                         {label:'梯形沟渠-沟渠宽度',prop:'trapezoidalDitch_DitchesWidth',minWidth:'130',sortable: false,hidden:false},  
                         {label:'梯形沟渠-沟渠深度',prop:'trapezoidalDitch_DitchDepth',minWidth:'100',sortable: false,hidden:false},
                         {label:'季节性河道-安装高度',prop:'seasonalRivers_MountingHeight',minWidth:'100',sortable: false,hidden:false},
                         {label:'季节性河道-离岸距离',prop:'seasonalRivers_OffshoreDistance',minWidth:'100',sortable: false,hidden:false},
                         {label:'季节性河道-河床深度',prop:'seasonalRivers_RiverBedDepth',minWidth:'130',sortable: false,hidden:false},  
                         {label:'季节性河道-杂草高度',prop:'seasonalRivers_WeedHeight',minWidth:'100',sortable: false,hidden:false},
                         {label:'水面状态',prop:'surfaceState',minWidth:'100',sortable: false,hidden:false},
                         {label:'介电常数',prop:'Dielectric',minWidth:'130',sortable: false,hidden:false},  
                         {label:'探头类型',prop:'ProbeType',minWidth:'100',sortable: false,hidden:false},
                         {label:'物位速度',prop:'LevelSpeed',minWidth:'100',sortable: false,hidden:false},
                         {label:'低位盲区',prop:'LowNearBlank',minWidth:'100',sortable: false,hidden:false},
                         {label:'高位盲区',prop:'near_blank',minWidth:'130',sortable: false,hidden:false},  
                         {label:'角度锁定',prop:'Angle_lock',minWidth:'100',sortable: false,hidden:false},
                         {label:'敏感度',prop:'Sensitivity',minWidth:'100',sortable: false,hidden:false},
                         {label:'休眠模式',prop:'Work_mode',minWidth:'100',sortable: false,hidden:false},
                         {label:'横滚补偿角',prop:'Roll_comp_angle',minWidth:'130',sortable: false,hidden:false},  
                         {label:'俯仰补偿角',prop:'Pitch_comp_angle',minWidth:'100',sortable: false,hidden:false},
                         {label:'最大流速',prop:'Maximal_velocity',minWidth:'100',sortable: false,hidden:false},
                         {label:"流速偏量",prop:"Velocity_Adj",minWidth:"100",sortable:!1,hidden:!1}

                        ],
                column4:[{label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'最小空位高度值',prop:'min_distance',minWidth:'200',sortable: false,hidden:false},
                         {label:'最大空位高度值',prop:'max_distance',minWidth:'100',sortable: false,hidden:false},
                         {label:'传感器状态',prop:'sensor_status',minWidth:'130',sortable: false,hidden:false},  
                         {label:'停止仿真/开始',prop:'simulate_status',minWidth:'100',sortable: false,hidden:false},
                         {label:'诊断-输出电流',prop:'simulate_value',minWidth:'150',sortable: false,hidden:false},
                         {label:'新建虚假回波',prop:'new_false_echo',minWidth:'100',sortable: false,hidden:false},
                         {label:'修改虚假回波',prop:'modify_false_echo',minWidth:'150',sortable: false,hidden:false},
                         {label:'删除虚假回波',prop:'delete_false_echo',minWidth:'100',sortable: false,hidden:false},
                         {label:'扩展',prop:'extend',minWidth:'150',sortable: false,hidden:false},
                        ],
                column5:[{label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'输出电流模式',prop:'ouput_mode',minWidth:'200',sortable: false,hidden:false},
                         {label:'故障模式',prop:'fail_mode',minWidth:'100',sortable: false,hidden:false},
                         {label:'最小电流',prop:'min_current',minWidth:'130',sortable: false,hidden:false},  
                         {label:'复位',prop:'reset',minWidth:'100',sortable: false,hidden:false},
                         {label:'单位',prop:'unit',minWidth:'150',sortable: false,hidden:false},
                         {label:'菜单语言',prop:'language',minWidth:'100',sortable: false,hidden:false},
                         {label:'485工作模式',prop:'hart_485_model',minWidth:'150',sortable: false,hidden:false},
                         {label:'RTU-DEV',prop:'RTU_DEV',minWidth:'100',sortable: false,hidden:false},
                         {label:'密码启用',prop:'password_index',minWidth:'150',sortable: false,hidden:false},
                         {label:'密码',prop:'password_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'距离偏量',prop:'dist_adj',minWidth:'200',sortable: false,hidden:false},
                         {label:'回波(评估)阈值',prop:'echothreshold',minWidth:'100',sortable: false,hidden:false},
                         {label:'包络线幅度',prop:'envelope_value',minWidth:'130',sortable: false,hidden:false},  
                         {label:'自动增益',prop:'auto_gain',minWidth:'100',sortable: false,hidden:false},
                         {label:'继电器开关',prop:'relay_status',minWidth:'150',sortable: false,hidden:false},
                         {label:'低位闭合阈值',prop:'LowPerThr',minWidth:'100',sortable: false,hidden:false},
                         {label:'高位闭合阈值',prop:'HighPerThr',minWidth:'100',sortable: false,hidden:false},
                         {label:'继电器报警延时',prop:'action_elay',minWidth:'100',sortable: false,hidden:false},
                         {label:'显示内容',prop:'display_index',minWidth:'130',sortable: false,hidden:false},  
                         {label:'扩展',prop:'extend',minWidth:'100',sortable: false,hidden:false},
                         {label:'LCD背光',prop:'lcd_BKLIGHT',minWidth:'150',sortable: false,hidden:false},
                         {label:'虚假回波距离值',prop:'FalseEchoDist',minWidth:'100',sortable: false,hidden:false},
                         {label:'滤波曲线抬升',prop:'FilterUplift',minWidth:'100',sortable: false,hidden:false},
                         {label:'滤波器',prop:'addWindowIndex',minWidth:'130',sortable: false,hidden:false},  
                         {label:'填充速度',prop:'dncreaseRate',minWidth:'100',sortable: false,hidden:false},
                         {label:'排空速度',prop:'echo_Intensity_Level',minWidth:'150',sortable: false,hidden:false},
                         {label:'回波强度等级',prop:'guideModeIndex',minWidth:'100',sortable: false,hidden:false},
                         {label:'引导模式',prop:'reliability',minWidth:'100',sortable: false,hidden:false},
                         {label:'可靠性',prop:'creted_time',minWidth:'130',sortable: false,hidden:false},  
                         {label:'缆长设定',prop:'CableLength',minWidth:'100',sortable: false,hidden:false},
                         {label:'首波选择',prop:'FirstEchoIndex',minWidth:'100',sortable: false,hidden:false},
                         {label:'跳变方式',prop:'JumpWay',minWidth:'100',sortable: false,hidden:false},
                         {label:'跳变距离',prop:'JumpDistance',minWidth:'130',sortable: false,hidden:false},  
                         {label:'跳变速度',prop:'JumpSpeed',minWidth:'100',sortable: false,hidden:false},
                         {label:'等待时间',prop:'WaitTime',minWidth:'100',sortable: false,hidden:false}
                        ],
                column6:[{label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'PQC模式',prop:'PQCType',minWidth:'200',sortable: false,hidden:false},
                        {label:'温度补偿开关',prop:'TempCompCtrl',minWidth:'100',sortable: false,hidden:false},
                         {label:'温度标定',prop:'Temp',minWidth:'130',sortable: false,hidden:false},  
                         {label:'TGC',prop:'TGC',minWidth:'100',sortable: false,hidden:false},
                         {label:'继电器设置',prop:'RelaySet',minWidth:'150',sortable: false,hidden:false},
                         {label:'重启次数',prop:'RebootTimes',minWidth:'100',sortable: false,hidden:false},
                         {label:'精度标定',prop:'PrecisionCal',minWidth:'150',sortable: false,hidden:false},
                         {label:'锯齿波平滑宽度',prop:'SmoothWidth',minWidth:'100',sortable: false,hidden:false},
                         {label:'填充异常次数',prop:'FillExceptionTimes',minWidth:'150',sortable: false,hidden:false},
                         {label:'排空异常次数',prop:'EmptyExceptionTimes',minWidth:'110',sortable: false,hidden:false},
                         {label:'波形阻尼',prop:'EchoDamping',minWidth:'200',sortable: false,hidden:false},
                         {label:'窗口跟踪',prop:'WindowTrack',minWidth:'100',sortable: false,hidden:false},
                         {label:'窗口宽度',prop:'WindowWidth',minWidth:'130',sortable: false,hidden:false},  
                         {label:'窗口起点',prop:'WindowStart',minWidth:'100',sortable: false,hidden:false},
                         {label:'跟踪时间',prop:'TrackTime',minWidth:'150',sortable: false,hidden:false},
                         {label:'显示增强',prop:'ShowEnhance',minWidth:'100',sortable: false,hidden:false},
                         {label:'线性K值',prop:'Cal_K',minWidth:'100',sortable: false,hidden:false},
                         {label:'线性B值',prop:'Cal_B',minWidth:'100',sortable: false,hidden:false},
                         {label:'ADC值',prop:'fADC',minWidth:'130',sortable: false,hidden:false},  
                         {label:'发增益',prop:'Tx_Gain',minWidth:'100',sortable: false,hidden:false},
                         {label:'收增益',prop:'Rx_Gain',minWidth:'150',sortable: false,hidden:false},
                         {label:'频道选择',prop:'ChannelSelect',minWidth:'100',sortable: false,hidden:false},
                         {label:'RAMP值',prop:'nRamp',minWidth:'100',sortable: false,hidden:false},
                         {label:'4-20mA电流使能',prop:'CurrentEnable',minWidth:'130',sortable: false,hidden:false},  
                         {label:'ADC开关',prop:'ADC_Switch',minWidth:'100',sortable: false,hidden:false},
                         {label:'对数曲线倍数',prop:'curve_log_multi',minWidth:'150',sortable: false,hidden:false},
                         {label:'对数曲线基数',prop:'curve_log_base',minWidth:'100',sortable: false,hidden:false},
                         {label:'窄波过滤宽度',prop:'narrow_flt_width',minWidth:'100',sortable: false,hidden:false},
                         {label:'一阶平滑参数',prop:'first_sp',minWidth:'130',sortable: false,hidden:false},  
                         {label:'二阶平滑参数',prop:'second_sp',minWidth:'100',sortable: false,hidden:false},
                         {label:'三阶平滑参数',prop:'third_sp',minWidth:'100',sortable: false,hidden:false},
                         {label:'4mA电流标定',prop:'_4mACal',minWidth:'100',sortable: false,hidden:false},
                         {label:'20mA电流标定',prop:'_20mACal',minWidth:'130',sortable: false,hidden:false},  
                         {label:'起点百分比',prop:'StartPercent',minWidth:'100',sortable: false,hidden:false},
                         {label:'分频等级',prop:'Frequency_div_level',minWidth:'100',sortable: false,hidden:false},
                         {label:'子带高度',prop:'Subband_height',minWidth:'130',sortable: false,hidden:false},  
                         {label:'子带宽度',prop:'Subband_width',minWidth:'100',sortable: false,hidden:false},
                         {label:'子带幅度系数',prop:'Subband_amp_coef',minWidth:'100',sortable: false,hidden:false},
                         {label:'窗函数类型',prop:'Window_func_type',minWidth:'100',sortable: false,hidden:false},
                         {label:'基频',prop:'Fund_frequency',minWidth:'130',sortable: false,hidden:false},  
                         {label:'ADC数据采样开关',prop:'ADC_sampling_switch',minWidth:'100',sortable: false,hidden:false},
                         {label:'基准高度',prop:'Reference_height',minWidth:'100',sortable: false,hidden:false},
                         {label:'回波显示方法',prop:'Echo_display_mode',minWidth:'100',sortable: false,hidden:false},
                         {label:'回波显示高度',prop:'Echo_display_height',minWidth:'100',sortable: false,hidden:false},
                         {label:'滤波警戒',prop:'Filtering_alert',minWidth:'130',sortable: false,hidden:false},  
                         {label:'滤波阈值',prop:'Filtering_threshold',minWidth:'100',sortable: false,hidden:false},
                         {label:'滤波大小',prop:'Filtering_size',minWidth:'100',sortable: false,hidden:false},
                        ],
                column7:[{label:'序列号',prop:'serial_num',minWidth:'110',sortable: false,hidden:false},
                         {label:'当前距离',prop:'cur_dist',minWidth:'200',sortable: false,hidden:false},
                         {label:'实时距离',prop:'oper_dist',minWidth:'100',sortable: false,hidden:false},
                         {label:'回波曲线',prop:'echo_data',minWidth:'130',sortable: false,hidden:false},  
                         {label:'回波曲线2',prop:'echo_data_pack2',minWidth:'100',sortable: false,hidden:false},
                         {label:'回波曲线3',prop:'echo_data_pack3',minWidth:'150',sortable: false,hidden:false},
                         {label:'滤波曲线',prop:'filter_data',minWidth:'100',sortable: false,hidden:false},
                         {label:'滤波曲线2',prop:'filter_data_pack2',minWidth:'150',sortable: false,hidden:false},
                         {label:'滤波曲线3',prop:'filter_data_pack3',minWidth:'100',sortable: false,hidden:false},
                         {label:'虚假回波曲线',prop:'false_echo_data',minWidth:'150',sortable: false,hidden:false},
                         {label:'虚假回波曲线2',prop:'false_echo_data_pack2',minWidth:'100',sortable: false,hidden:false},
                         {label:'虚假回波曲线3',prop:'false_echo_data_pack3',minWidth:'150',sortable: false,hidden:false},
                         {label:'虚假回波当前距离',prop:'false_echo_distance',minWidth:'100',sortable: false,hidden:false}
                        ],
                isFull:false,
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    page: 1,
                    limit: 10,
                },
                pageparm: {
                    page: 1,
                    limit: 10,
                    total: 0,
                },
                defaultImg:require('../assets/img/avatar.jpg'),
                statusList:[
                    {id:1,name:'是'},
                    {id:0,name:'否'}
                ],
                identityList:[
                    {id:0,name:'普通用户'},
                    {id:1,name:'会员'},
                ],
                tableData:[],
                timers:[],
                drawer:false,
                drawerIndeterminate:true,
                drawerCheckedValue:[],
                // 选项框选中数组
                ids: [],
                // 选项框非单个禁用
                single: true,
                // 非多个禁用
                multiple: true,
                showSearchBar:true,
                //弹窗
                isDialogShow:false,
                dialogTitle:"",
                formData:{},
                rules:{},
                formColumns:[],
                loadingSave:false,
                formDisabled:false,
            }
        },
        props: {
             // 表头配置
            tableColumns: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            Columns1: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            //是否显示分页
            showPagination: {
                type: Boolean,
                default: true
            },
            //分页参数
            pageparams:{
                type: Object,
                default: () => {
                    return {
                        limit: 10,
                        pageSizes:[10,20,30,40,50,100],
                        layout:'total, sizes, prev, pager, next, jumper',
                    }
                }
            },
            // 是否显示复选框
            showSelectable: {
              type: Boolean,
              default: false
            },
            // 是否显示序号列
            showSequence: {
              type: Boolean,
              default: true
            },
            // 行唯一值
            rowKey: {
              type: String,
              default: 'id'
            },
            //操作列属性
            rowHandle:{
                type: Object,
                default:() => {
                    return{
                        width: 180,//操作列宽度
                        fixed:false,//类型：string/boolean	true false / 'left' / 'right',默认不固定
                        permission:{
                            add:true,
                            del:true,
                            edit:true,
                            search:true,
                            detail:true,
                        }
                    }
                },
            },
            //增删改查httpq请求方法
            crudRequest:{
                type: Object,
                default:() => {
                    return{
                        add:Function,
                        del:Function,
                        edit:Function,
                        search:Function,
                    }
                }
            },
            //搜索栏目配置
            searchBar:{
                type: Object,
                default:() => {
                    return{
                        showSearchBar:true,//是否显示搜索栏目
                        searchColums:[]
                    }
                }
            },
            //dialog表单
            formOptions:{
                type: Object,
                default: () => {
                    return{
                        width: '560px',//dialog弹窗宽度：类型：百分比或字符串
                        gutter: 20, // Layout布局栅格间隔
                    }
                }
            },
            //表格属性
            tableOptions:{
                type: Object,
                default: () => {
                    return {
                        stripe: false, // 斑马纹
                        highlightCurrentRow: false, // 是否要高亮当前行
                        border: true, // 是否有纵向边框
                        fit: true, // 列的宽度是否自撑开
                        size: 'default', // Table 的尺寸
                        lazy:false,// 是否需要懒加载
                        showHeader:true,//是否显示表头
                        defaultExpandAll:false,//是否默认展开所有行
                    }
                }
            },


        },
        watch:{
            pageparams(newValue, oldValue){
                this.pageparm.limit = newValue.limit?newValue.limit:this.pageparm.limit
            },
            searchBar(newValue, oldValue){
                this.showSearchBar = newValue.showSearchBar
            },
            showSearchBar(newValue, oldValue){
                this.$nextTick(() => {
                    this.getTheTableHeight()
                })
            }

        },
        created() {
            this.showSearchBar = this.searchBar.showSearchBar
            this.pageparm.limit = this.pageparams.limit?this.pageparams.limit:this.pageparm.limit
            this.formInline.limit = this.pageparm.limit
            this.formColumns = this.tableColumns.filter(item=>{
                if(item.form !== undefined ){
                    return true
                }else{
                    return false
                }
            })
            this.rules = {}
            this.formColumns.forEach(item=>{
                if(item.form.rules !== undefined){
                    this.rules[item.prop] = item.form.rules
                }
            })
            this.getData()
        },
        methods:{
            // 表格序列号（递增，翻页不重置）
            getTableIndex($index) {
            // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            setFull(){
                this.isFull=!this.isFull
                window.dispatchEvent(new Event('resize'))
            },
            //多选项框被选中数据
            handleSelectionChange(selection) {
                this.ids = selection.map(item => item.id);
                this.single = selection.length !== 1;
                this.multiple = !selection.length;
            },
            /** 批量删除按钮操作 */
            handleMutiDelete() {
                const ids = this.ids;
                let vm = this
                vm.$confirm('是否确认删除选中的数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return vm.crudRequest.del({id:ids}).then(res=>{
                        if(res.code == 2000) {
                            vm.ids=[]
                            vm.single=true
                            vm.multiple=false
                            vm.$message.success(res.msg)
                            vm.handleRefresh()
                        } else {
                            vm.$message.warning(res.msg)
                        }
                    })
                })
            },
            ChangetableColumns(val){
                let num_type = val
                if(num_type == null ||num_type==""){
                    num_type= 1  
                }
                let tl = this.tableColumns.length
                console.log(tl)
                for(let i=0;i<tl;i++){
                    this.tableColumns.pop()
                }
                this.tableColumns.push({label:'更新时间',prop:'change_time',minWidth:'150',sortable: false,hidden:false })  
                if(num_type == 1){
                    for(let i=0;i<this.column1.length;i++){
                        this.tableColumns.push(this.column1[i])
                    }
                }else if(num_type == 2){
                    for(let i=0;i<this.column2.length;i++){
                        this.tableColumns.push(this.column2[i])
                    }
                }else if(num_type == 3){
                    for(let i=0;i<this.column3.length;i++){
                        this.tableColumns.push(this.column3[i])
                    }
                }else if(num_type == 4){
                    for(let i=0;i<this.column4.length;i++){
                        this.tableColumns.push(this.column4[i])
                    }
                }else if(num_type == 5){
                    for(let i=0;i<this.column5.length;i++){
                        this.tableColumns.push(this.column5[i])
                    }
                }else if(num_type == 6){
                    for(let i=0;i<this.column6.length;i++){
                        this.tableColumns.push(this.column6[i])
                    }
                }else if(num_type == 7){
                    for(let i=0;i<this.column7.length;i++){
                        this.tableColumns.push(this.column7[i])
                    }
                }
   
            },
            handleDrawerColumnsChange(val){
                // this.$emit('update:tableColumns', this.Columns1);
                const newColumns = this.tableColumns.map(item=>{
                    let newitem = item
                    if(this.drawerCheckedValue.includes(item.label)){
                        // newitem.label="test"
                        newitem.hidden = false
                    }else{
                        newitem.hidden = true
                    }
                    return newitem
                })
                this.$emit('update:tableColumns', newColumns);
            },
            handleDrawerCheckAllChange(val){
                this.drawerCheckedValue  = val ? this.tableColumns.map(item=> item.label) : []
                const newColumns = this.tableColumns.map(item=>{
                    let newitem = item
                    if(val){
                        newitem.hidden = false
                    }else{
                        newitem.hidden = true
                    }
                    return newitem
                }) 
                this.$emit('update:tableColumns', newColumns);
                this.drawerIndeterminate  = false

            },
            //searchBar点击事件
            handleSearchClick(flag){
                if(flag=="search"){
                    this.search()
                }
                else if(flag=="reset"){
                    this.formInline = {
                        page:1,
                        limit: this.pageparm.limit,
                        // data_type:1
                    }
                    this.timers = []
                    this.getData()
                    this.ChangetableColumns(this.formInline.data_type)
                }
            },
            handleRefresh(){
                this.getData()
            },
            handleEdit(row,flag) {
                let vm = this
                if(flag=='del') {
                    vm.$confirm('您确定要删除该条数据吗？',{
                        closeOnClickModal:false
                    }).then(res=>{
                        vm.crudRequest.del({id:row.id}).then(res=>{
                            if(res.code == 2000) {
                                vm.$message.success(res.msg)
                                vm.handleRefresh()
                            } else {
                                vm.$message.warning(res.msg)
                            }
                        })
                    }).catch(()=>{

                    })
                }
                else if (flag=='detail'){
                    this.dialogTitle = "详情"
                    this.formDisabled = true
                    this.tableColumns.forEach(item=>{
                        this.formData[item.prop] = row[item.prop]
                    })
                    this.isDialogShow = true
                }
                else if(flag=='add'){
                    this.dialogTitle = "添加"
                    //默认值处理
                    this.formColumns.forEach(item=>{
                         if(item.form.defaultValue !==undefined){
                             this.formData[item.prop] = item.form.defaultValue
                         }
                         if(item.prop === "password" && item.form.rules!==undefined){
                            this.rules.password = item.form.rules
                        }
                     })
                    this.isDialogShow = true
                }
                else if(flag=='edit'){
                    this.dialogTitle = "编辑"
                    this.formColumns.forEach(item=>{
                        this.formData[item.prop] = row[item.prop]
                        if(item.prop === "password"){
                            delete this.rules.password
                        }
                    })
                    this.isDialogShow = true
                }
            },
            handleDialogClose(){
                this.isDialogShow = false
                this.loadingSave =false
                this.formData = {}
                this.formDisabled = false
            },
            submitData() {
                this.$refs['rulesForm'].validate((obj)=>{
                    if(obj) {
                        this.loadingSave=true
                        let param = {
                            ...this.formData
                        }
                        if(this.dialogTitle=="编辑"){
                            this.crudRequest.edit(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleDialogClose()
                                    this.handleRefresh()
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }else{
                            this.crudRequest.add(param).then(res=>{
                                this.loadingSave=false
                                if(res.code ==2000) {
                                    this.$message.success(res.msg)
                                    this.handleDialogClose()
                                    this.search()
                                } else {
                                    this.$message.warning(res.msg)
                                }
                            })
                        }

                    }
                })
                this.loadingSave=false
            },
            /**
             * 从URL里下载文件
            */
            // 下载文件
            downloadFileURL(url) {
                var iframe =document.createElement("iframe")
                iframe.style.display ="none";
                iframe.src = url;
                document.body.appendChild(iframe);
            },
            exportDataBackend() {
                var params = {
                    page: 1,
                    limit: 9999,
                }
                // UsersUsersExportexecl(params).then(res => {
                //      if(res.code ==2000) {
                //          this.downloadFileURL(res.data.data)
                //          //this.$message.warning(res.data.data)
                //      }
                //  })
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.pageparm.page = parm.page
                this.pageparm.limit = parm.limit
                this.getData()
            },
            search() {
                
                if(this.formInline.data_type != null){
                    this.ChangetableColumns(this.formInline.data_type)
                }
                console.log(this.formInline)
                this.formInline.page = 1
                this.formInline.limit = this.pageparm.limit
                this.getData()
            },
            //获取列表
            async getData() {
                this.loadingPage = true
                this.crudRequest.search(this.formInline).then(res => {
                     this.loadingPage = false
                     if(res.code ==2000) {
                         this.tableData = res.data.data
                         this.pageparm.page = res.data.page;
                         this.pageparm.limit = res.data.limit;
                         this.pageparm.total = res.data.total;
                     }
                 })
            },

            timeChange(val){
                if (val) {
                    this.formInline.beginAt=dateFormats(val[0],'yyyy-MM-dd hh:mm:ss');
                    this.formInline.endAt=dateFormats(val[1],'yyyy-MM-dd hh:mm:ss');
                } else {
                    this.formInline.beginAt = null
                    this.formInline.endAt = null
                }
                this.search()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let searchBarHeight = (this.$refs.tableSelect!=undefined && this.$refs.tableSelect.offsetHeight)?this.$refs.tableSelect.offsetHeight:0
                const tableToolbarHeight = (this.$refs.tableToolBar!=undefined && this.$refs.tableToolBar.offsetHeight)?this.$refs.tableToolBar.offsetHeight:0
                searchBarHeight = this.isFull?searchBarHeight - 110:searchBarHeight
                this.tableHeight =  getTableHeight(searchBarHeight+tableToolbarHeight)
            }

        },
        //解决table 表格缩放错位问题
        handleResize() {
            this.$nextTick(()=> {
                this.$refs.tableref.doLayout();
            });
        },
        mounted() {
            //解决table 表格缩放错位问题
            window.addEventListener('resize', this.handleResize);
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
            //解决table 表格缩放错位问题
            window.removeEventListener("resize", this.handleResize);
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
<style lang="scss" scoped>
    .tableToolBar{
        margin-left: 1px;
        margin-right: 1px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        background: var(--el-bg-color);
        padding: 10px;
        box-shadow: 0 0 4px #cccccc;
    }
</style>